module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn role-overlay",
    class: {
      disabled: _vm.noshow === true
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/role_overlay.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "node-icon-holder"
  }, [_c('img', {
    staticClass: "node-icon",
    attrs: {
      "src": _vm.nodeIconImage
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "blue-bar",
    attrs: {
      "src": "media/page3/blue_box.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title-holder"
  }, [_c('h5', {
    staticClass: "title animated fadeIn"
  }, [_vm._v(_vm._s((this.$store.state.activeNode === null) ? null : _vm.nodePath.nodeTitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-152e228c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoleOverlay.vue
// module id = 126
// module chunks = 0